import * as _ from 'lodash';
import {IMinistryResource} from '../../core/services/MinistryService'
import {IAgencyResource} from '../../core/services/AgencyService'
export class OrganizationManagementPageComponent implements ng.IComponentOptions {
  public controller: any = OrganizationManagementController;
  public template: string =
    `<h2>Organisation Management <span class="subtitle">- {{$ctrl.title[$ctrl.type]}}</span><button ng-show="$ctrl.type == 'ministry'" class="btn btn-primary pull-right" ng-click="$ctrl.addMinistry()">ADD NEW</button><button ng-show="$ctrl.type == 'agency'" class="btn btn-primary pull-right" ng-click="$ctrl.addAgency()">ADD NEW</button></h2>
      <div ng-show="$ctrl.type == 'ministry'">
        <div class="row padding-top">
          <div class="col-md-8">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search" ng-model="searchText.ministry.$"/>
              <span class="input-group-btn">
                <button class="btn btn-default">
                  <i class="fa fa-fw fa-search"></i>
                </button>
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <ui-select ng-model="searchText.ministry.state" name="status" required>
              <ui-select-match placeholder="Choose State">
                <span ng-bind="$select.selected.name"></span>
              </ui-select-match>
              <ui-select-choices repeat="item.type as item in ($ctrl.states | filter: $select.search)">
                <span ng-bind="item.name"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
        <table class="table table-striped table-hover" ng-init="searchText.ministry.state='!inactive'">
          <thead>
            <tr>
              <th><input type="checkbox" ng-model="$ctrl.selectedAll.ministry" ng-change="$ctrl.selectAllMinistry($ctrl.selectedAll.ministry)"/></th>
              <th>Ministry Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('ministry','display_name')"></i></th>
              <th>Code<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('ministry','code')"></i></th>
              <th>Status<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('ministry','state')"></i></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="ministry in $ctrl.ministries | filter: searchText.ministry | orderBy: $ctrl.sortType.ministry: $ctrl.reverse.ministry">
              <td><input type="checkbox" ng-model="ministry.selected" /></td>
              <td>{{ministry.display_name}}</td>
              <td>{{ministry.code}}</td>
              <td>{{ministry.state}}</td>
              <td><i class="fa fa-fw fa-pencil btn-icon" uib-tooltip="Edit Ministry" ng-click="$ctrl.editMinistry(ministry)"></i></td>
            </tr>
          </tbody>
        </table>
        <div class="row padding-bottom">
          <div class="col-md-12">
            <button class="btn btn-default" type="button" ng-click="$ctrl.activateMinistry(true)">ACTIVATE</button>
            <button class="btn btn-default" type="button" ng-click="$ctrl.activateMinistry(false)">DEACTIVATE</button>
          </div>
        </div>
      </div>
      <div ng-show="$ctrl.type == 'agency'">
      <div class="row padding-top">
      <div class="col-md-8">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Search" ng-model="searchText.agency.$" />
          <span class="input-group-btn">
            <button class="btn btn-default">
              <i class="fa fa-fw fa-search"></i>
            </button>
          </span>
        </div>
        </div>
        <div class="col-md-4">
          <ui-select ng-model="searchText.agency.state" name="status" required>
            <ui-select-match placeholder="Choose State">
              <span ng-bind="$select.selected.name"></span>
            </ui-select-match>
            <ui-select-choices repeat="item.type as item in ($ctrl.states | filter: $select.search)">
              <span ng-bind="item.name"></span>
            </ui-select-choices>
          </ui-select>
        </div>
      </div>
      <table class="table table-striped table-hover" ng-init="searchText.agency.state='!inactive'">
        <thead>
          <tr>
            <th><input type="checkbox" ng-model="$ctrl.selectedAll.agency" ng-change="$ctrl.selectAllAgency($ctrl.selectedAll.agency)" /></th>
            <th>Agency Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('agency','display_name')"></i></th>
            <th>Code<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('agency','code')"></i></th>
            <th>Ministry<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('agency','ministry.display_name')"></i></th>
            <th>Status<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('agency','state')"></i></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="agency in $ctrl.agencies | filter: searchText.agency | orderBy: $ctrl.sortType.agency: $ctrl.reverse.agency">
            <td><input type="checkbox" ng-model="agency.selected"/></td>
            <td>{{agency.display_name}}</td>
            <td>{{agency.code}}</td>
            <td>{{agency.ministry.display_name}}</td>
            <td>{{agency.state}}</td>
            <td><i class="fa fa-fw fa-pencil btn-icon" uib-tooltip="Edit Agency" ng-click="$ctrl.editAgency(agency)"></i></td>
          </tr>
        </tbody>
      </table>
      <div class="row padding-bottom">
        <div class="col-md-12">
          <button class="btn btn-default" type="button" ng-click="$ctrl.activateAgency(true)">ACTIVATE</button>
          <button class="btn btn-default" type="button" ng-click="$ctrl.activateAgency(false)">DEACTIVATE</button>
        </div>
      </div>
      </div>
    `;
}

export class OrganizationManagementController {
  public static $inject: Array<string> = ["$scope", "$uibModal", "AgencyService", "MinistryService", "$stateParams"];
  public agencies: Array<any>;
  public ministries: Array<any>;
  public selectedAll: any;
  public sortType: any;
  public reverse: any;
  public type: string;
  public title: any;
  public states: Array<any>;
  constructor($scope: ng.IScope, private $uibModal: ng.ui.bootstrap.IModalService, private AgencyService: IAgencyResource, private MinistryService: IMinistryResource, private $stateParams: ng.ui.IStateParamsService) {
    $scope.$emit("adminPageChange",{name:"org"});
    this.loadMinistry();
    this.loadAgency();
    this.selectedAll = {ministry: false, agency: false};
    this.sortType = {ministry: "display_name", agency: "display_name"};
    this.reverse = {ministry: "", agency: ""};
    this.type = $stateParams.type || 'ministry';
    this.title = {
      'ministry': "Ministry",
      'agency': "Agency"
    }
    this.states = [
      {name: "Active", type: "!inactive"},
      {name: "Inactive", type: "inactive"},
      {name: "All Records", type: ""}
    ]
  }
  public loadMinistry() {
    this.ministries = this.MinistryService.query();
  }
  public loadAgency() {
    this.agencies = this.AgencyService.query({allFields:true});
  }
  public addMinistry() {
    let modalInstance = this.$uibModal.open({
      component: "ministryModal"
    })
    modalInstance.result.then((ministry) => {
      this.ministries.push(ministry);
    });
  }
  public addAgency() {
    let modalInstance = this.$uibModal.open({
      component: "agencyModal"
    })
    modalInstance.result.then((agency) => {
      this.agencies.push(agency);
    });
  }
  public editMinistry(ministry) {
    let modalInstance = this.$uibModal.open({
      component: "ministryModal",
      resolve: {
        ministry: () => {
          return ministry;
        }
      }
    });
    modalInstance.result.then((ministry) => {
      this.loadMinistry();
    })
  }
  public editAgency(agency) {
    let modalInstance = this.$uibModal.open({
      component: "agencyModal",
      resolve: {
        agency: () => {
          return agency;
        }
      }
    });
    modalInstance.result.then((agency) => {
      this.loadAgency();
    })
  }
  public selectAllMinistry(state) {
    _.each(this.ministries, (_ministry) => {
      _ministry.selected = state;
    })
  }
  public selectAllAgency(state) {
    _.each(this.agencies, (_agency) => {
      _agency.selected = state;
    })
  }
  public activateMinistry(active: boolean) {
    let _ministries = _.filter(this.ministries, {selected: true});
    if (_ministries.length) {
      let _names = _.reduce(_ministries, (res, ministry) => {
        return res + "<strong>" +  ministry.display_name + "</strong><br/>";
      },"");
      swal({
        type: "info",
        title: active?"Activate Ministry":"Deactivate Ministry",
        html: true,
        text: `Are you sure you want to ${active?"activate":"deactivate"} the following ministries<br/>${_names}`,
        showCancelButton: true
      }, (isConfirm) => {
        if (isConfirm) {
          _.each(_ministries, (_ministry) => {
            if (active)
              _ministry.state = "active";
            else
              _ministry.state = "inactive";
          })
          this.MinistryService.updateAll(_ministries).$promise.then(() => {
            this.ministries = this.MinistryService.query();
          })
        }
      })
    }
  }
  public activateAgency(active: boolean) {
    let _agencies = _.filter(this.agencies, {selected: true});
    if (_agencies.length) {
      let _names = _.reduce(_agencies, (res, agency) => {
        return res + "<strong>" +  agency.display_name + "</strong><br/>";
      },"");
      swal({
        type: "info",
        title: active?"Activate Agency":"Deactivate Agency",
        html: true,
        text: `Are you sure you want to ${active?"activate":"deactivate"} the following agencies<br/>${_names}`,
        showCancelButton: true
      }, (isConfirm) => {
        if (isConfirm) {
          _.each(_agencies, (_agency) => {
            if (active)
              _agency.state = "active";
            else
              _agency.state = "inactive";
          })
          this.AgencyService.updateAll(_agencies).$promise.then(() => {
            this.agencies = this.AgencyService.query({allFields: true});
          })
        }
      })
    }
  }
  public sortBy(org: string, type: string) {
    this.sortType[org] = type;
    this.reverse[org] = !this.reverse[org];
  }
}
